import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme: any) => ({
  section: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    borderRadius: '24px',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0 48px',
    padding: '64px 0',
    width: 'calc(100% - 96px)',
    '& > svg': {
      width: 'auto',
      height: '48px',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    gap: '16px',
    '& > h1': {
      fontWeight: '400',
      color: theme.colors.black,
    },
    '& > p': {
      color: theme.colors.grey[500],
      width: '50%',
      textAlign: 'center',
    },
  },
  leftSide: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    flex: '0 0 50%',
    maxHeight: '100%',
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      flex: '0 0 100%',
    },
  },
  rightSide: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    flex: '0 0 50%',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  icon: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
  },
  iconPlaceholder: {
    position: 'relative',
    width: '50%',
    paddingTop: '50%',
    '& > svg': {
      position: 'absolute',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      width: '100%',
      height: '100%',
      color: theme.colors.primaryBlue[500],
    },
  },
}));

export default useStyles;